module.exports = __webpack_public_path__ + "img/all-aboard.327861fd.png";